import { VirtualCardType } from 'modules/virtual-cards/constants'

/** Max benefit IDs per synchronous selection action — must match backend VCN_SELECTION_MAX_BENEFIT_IDS. */
export const VCN_SELECTION_MAX = 100

export interface VcnSelectionRequest {
  benefitIds: string[]
  /** Provider for created cards (create-new / terminate-and-new); backend defaults to WEX when omitted. */
  provider?: VirtualCardType
}

export interface VcnSelectionItemResult {
  benefitId: string
  success: boolean
  vcnProvider?: string
  errorMessage?: string
}

export interface VcnSelectionResponse {
  results: VcnSelectionItemResult[]
  successCount: number
  failedCount: number
}
